<template>
  <v-container fluid >
    <v-card outlined class="statistics-card">
      <div class="statistics-header">
        <div>
          <div class="section-title">Statistics</div>
          <div class="section-subtitle">Customer product sales by date range</div>
        </div>

        <DateTimePicker
          defaultRange="since30DaysAgo"
          :range="true"
          v-model="dateTime"
          @submit="submit"
        />
      </div>

      <v-card-text class="pa-4">
        <Product
          :hideCost="true"
          :hideProfit="true"
          :CustomerId="getCustomer.id"
          :start="dateTime.start"
          :end="dateTime.end"
          :reset="reset"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

const Product = () => import("@/modules/ReportView/GlobalReport/Product.vue");
const DateTimePicker = () => import("@/components/DateTimePicker");

export default {
  name: "customer-statistics",

  components: {
    Product,
    DateTimePicker,
  },

  data() {
    return {
      reset: false,
      dateTime: {},
    };
  },

  computed: {
    ...mapGetters("customer", ["getCustomer"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },

  methods: {
    submit() {
      this.reset = !this.reset;
    },
  },
};
</script>

<style scoped>
.customer-statistics-page {
  background: #f8fafc;
}

.statistics-card {
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
}

.statistics-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.section-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.section-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}
</style>